/*!
 * @Author: luoob
 * @Date: 2021-03-23 14:52:00
 * @Last Modified by: Robin
 * @Last Modified time: 2024-07-24 22:21:51
 * @Introduction: 设置模块路由
 */

import { RouteConfig } from 'vue-router'

const SettingInstitute = () => import('@/views/setting/institute/index.vue')
const SettingInstituteTypeCreate = () => import('@/views/setting/institute/type/create.vue')
const SettingInstituteTypeDetail = () => import('@/views/setting/institute/type/_id.vue')
const SettingInstituteArticleList = () => import('@/views/setting/institute/article/list.vue')
const SettingInstituteArticleCreate = () => import('@/views/setting/institute/article/create.vue')
const SettingInstituteArticleDetail = () => import('@/views/setting/institute/article/_id.vue')
const SettingInstituteTopList = () => import('@/views/setting/institute/top/list.vue')
const SettingInstituteTopCreate = () => import('@/views/setting/institute/top/create.vue')
import ArticleSection from '@/views/winpress/article/index.vue'
import ArticleTypeDetail from '@/views/winpress/article/type/_id.vue'
import ArticleTypeCreate from '@/views/winpress/article/type/create.vue'
import ArticleList from '@/views/winpress/article/list.vue'
import ArticleDetail from '@/views/winpress/article/_id.vue'
import ArticleCreate from '@/views/winpress/article/create.vue'


/* Layout */
import Layout from '@/layout/index.vue'
/* Children Layout */
import EmptyLayout from '@/layout/empty_layout.vue'

const settingContentRoute: RouteConfig = {
    path: '/content',
    component: Layout,
    redirect: '/content/institute',
    meta: {
        title: '内容运营',
        icon: 'icon-news',
        alwaysShow: true // will always show the root menu
    },
    children: [
        {
            path: 'institute',
            component: EmptyLayout,
            meta: {
                title: '牛媒研究院'
            },
            children: [
                {
                    path: '',
                    component: SettingInstitute,
                    name: 'ContentInstitute',
                    meta: {
                        title: '牛媒研究院'
                    }
                },
                {
                    path: 'type/new',
                    component: SettingInstituteTypeCreate,
                    name: 'ContentInstituteTypeCreate',
                    meta: {
                        title: '新增文章类型',
                        hidden: true
                    }
                },
                {
                    path: 'article/list',
                    component: SettingInstituteArticleList,
                    name: 'ContentInstituteArticleList',
                    meta: {
                        title: '文章列表',
                        hidden: true
                    }
                },
                {
                    path: 'article/create',
                    component: SettingInstituteArticleCreate,
                    name: 'ContentInstituteArticleCreate',
                    meta: {
                        title: '创建文章',
                        hidden: true
                    }
                },
                {
                    path: 'article/:id',
                    component: SettingInstituteArticleDetail,
                    name: 'ContentInstituteArticleDetail',
                    meta: {
                        title: '文章详情',
                        hidden: true
                    }
                },
                {
                    path: 'type/:id',
                    component: SettingInstituteTypeDetail,
                    name: 'ContentInstituteTypeDetail',
                    meta: {
                        title: '文章类型详情',
                        hidden: true
                    }
                },
                {
                    path: 'top/list',
                    component: SettingInstituteTopList,
                    name: 'ContentInstituteTopList',
                    meta: {
                        title: '置顶文章设置',
                        hidden: true
                    }
                },
                {
                    path: 'top/create',
                    component: SettingInstituteTopCreate,
                    name: 'ContentInstituteTopCreate',
                    meta: {
                        title: '添加置顶文章',
                        hidden: true
                    }
                }
            ]
        },
        {
            path: 'coolcompany',
            component: EmptyLayout,
            meta: {
                title: '酷公司'
            },
            children: [
                {
                    path: '',
                    component: SettingInstitute,
                    name: 'ContentCoolCompany',
                    meta: {
                        title: '酷公司'
                    }
                },
                {
                    path: 'type/new',
                    component: SettingInstituteTypeCreate,
                    name: 'ContentCoolCompanyTypeCreate',
                    meta: {
                        title: '新增文章类型',
                        hidden: true
                    }
                },
                {
                    path: 'article/list',
                    component: SettingInstituteArticleList,
                    name: 'ContentCoolCompanyArticleList',
                    meta: {
                        title: '文章列表',
                        hidden: true
                    }
                },
                {
                    path: 'article/create',
                    component: SettingInstituteArticleCreate,
                    name: 'ContentCoolCompanyArticleCreate',
                    meta: {
                        title: '创建文章',
                        hidden: true
                    }
                },
                {
                    path: 'article/:id',
                    component: SettingInstituteArticleDetail,
                    name: 'ContentCoolCompanyArticleDetail',
                    meta: {
                        title: '文章详情',
                        hidden: true
                    }
                },
                {
                    path: 'type/:id',
                    component: SettingInstituteTypeDetail,
                    name: 'ContentCoolCompanyTypeDetail',
                    meta: {
                        title: '文章类型详情',
                        hidden: true
                    }
                },
                {
                    path: 'top/list',
                    component: SettingInstituteTopList,
                    name: 'ContentCoolCompanyTopList',
                    meta: {
                        title: '置顶文章设置',
                        hidden: true
                    }
                },
                {
                    path: 'top/create',
                    component: SettingInstituteTopCreate,
                    name: 'ContentCoolCompanyTopCreate',
                    meta: {
                        title: '添加置顶文章',
                        hidden: true
                    }
                }
            ]
        },
        {
            path: 'winpress',
            component: EmptyLayout,
            meta: {
                title: '云发布'
            },
            children: [
                {
                    path: '',
                    component: ArticleSection,
                    name: 'ArticleSection',
                    meta: {
                        title: '云发布'
                    }
                },
                {
                    path: 'article/type/create',
                    component: ArticleTypeCreate,
                    name: 'ArticleTypeCreate',
                    meta: {
                        hidden: true,
                        title: '创建文章分类'
                    }
                },
                {
                    path: 'article/type/:id',
                    component: ArticleTypeDetail,
                    name: 'ArticleTypeDetail',
                    meta: {
                        hidden: true,
                        title: '文章分类详情'
                    }
                },
                {
                    path: 'article/list/:id',
                    component: ArticleList,
                    name: 'ArticleList',
                    meta: {
                        hidden: true,
                        title: '文章列表'
                    }
                },
                {
                    path: 'article/:id/create',
                    component: ArticleCreate,
                    name: 'ArticleCreate',
                    meta: {
                        hidden: true,
                        title: '创建文章'
                    }
                },
                {
                    path: 'article/:id',
                    component: ArticleDetail,
                    name: 'ArticleDetail',
                    meta: {
                        hidden: true,
                        title: '文章详情'
                    }
                }
            ]
        }
    ]
}

export default settingContentRoute
